import { render, staticRenderFns } from "./BannerImage.vue?vue&type=template&id=5b5c049c"
import script from "./BannerImage.vue?vue&type=script&lang=js"
export * from "./BannerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports